import Joi from '@hapi/joi'

export const CollectionSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    collectionPointID: Joi.number().label("CollectionPoint").messages({
        "any.invalid": `Select CollectionPoint`,
        "any.required": `CollectionPoint required`
    }),
    date: Joi.string().invalid("").required().label("Search Date"),       
}